module.exports = __webpack_public_path__ + "static/media/kit_weatherStation.251fdb94.png";